<div class="dashboard heisenberg-background">
    <div class='content'>
        <h1 class="mb-3">\(o_o)/</h1>
        <h3 class="mt-2">The resource you are looking for does not exist</h3>
        <button mat-raised-button color="primary" routerLink="/portal">
            <mat-icon>rocket_launch</mat-icon> Go home
        </button>
    </div>
</div>
